// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3YrFd","clinicsSelect":"TableHeading_clinicsSelect__dJ2TL"};